var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAcceptQuality(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.1929 6.59059C14.8047 6.62823 14.52 6.97176 14.5576 7.36C14.5788 7.57176 14.5882 7.78588 14.5882 8C14.5882 11.6329 11.6329 14.5882 8 14.5882C4.36706 14.5882 1.41176 11.6329 1.41176 8C1.41176 4.36706 4.36706 1.41176 8 1.41176C8.96471 1.41176 9.89412 1.61647 10.7624 2.01647C11.1153 2.18118 11.5365 2.02588 11.6988 1.67294C11.8635 1.32 11.7082 0.898823 11.3553 0.73647C10.2988 0.247059 9.17176 0 8 0C3.58824 0 0 3.58824 0 8C0 12.4118 3.58824 16 8 16C12.4118 16 16 12.4118 16 8C16 7.74118 15.9882 7.48 15.9624 7.22588C15.9247 6.83765 15.5812 6.55529 15.1929 6.59059Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.53637 8.89156L5.20461 6.5598C4.92931 6.2845 4.48225 6.2845 4.20696 6.5598C3.93166 6.83509 3.93166 7.28215 4.20696 7.55744L7.03049 10.381C7.16696 10.5198 7.34813 10.588 7.52931 10.588C7.70578 10.588 7.88461 10.5221 8.02108 10.388L15.7858 2.85862C16.0658 2.58803 16.0728 2.14097 15.8023 1.86097C15.5317 1.58097 15.0846 1.57391 14.8046 1.84685L7.53637 8.89156Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAcceptQuality);
export default __webpack_public_path__ + "static/media/acceptQuality.c2ce7af6f835d8d4f5df042e581d840b.svg";
export { ForwardRef as ReactComponent };